/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gateway_Card_SubtitleInputs */



/**
* | output |
* | --- |
* | "API-first access for developers and automation platforms" |
*
* @param {Gateway_Card_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gateway_card_subtitle = /** @type {((inputs?: Gateway_Card_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Card_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("API-First-Zugang für Entwickler und Automatisierungsplattformen")
	return /** @type {LocalizedString} */ ("API-first access for developers and automation platforms")
});